import router from '@/router'

//路由守卫
router.beforeEach(({path, meta}, from, next) => {
    console.log('beforeEach...',path,meta);
    next();
});

export const routerBefore = router;
